'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import { useNewMatterStore } from '@repo/store/useNewMatterStore'

export const WorktypeSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required,
  errors = {},
  multiple = false
}) => {
  const { fetchWorkflowTypes, workflowTypes } = useLookupsStore()
  const { worktype } = useNewMatterStore()
  const [options, setOptions] = useState(testData || workflowTypes || [])
  const [selectedValue, setSelectedValue] = useState(value)

  useEffect(() => {
    if (testData) return
    setOptions(workflowTypes || [])
  }, [testData, workflowTypes])

  useEffect(() => {
    if (testData || workflowTypes?.length) return
    fetchWorkflowTypes()
  }, [testData, workflowTypes, fetchWorkflowTypes])

  useEffect(() => {
    // Check if value is a number and update the selectedValue accordingly
    if (worktype) {
      setSelectedValue(worktype)
    } else if (typeof value === 'string') {
      const selectedOption = options.find((option) => option.workflowTypeId === value)
      if (selectedOption) {
        setSelectedValue(selectedOption)
      }
    } else {
      setSelectedValue(value)
    }
  }, [value, options, worktype])

  return (
    <div data-testid="WorktypeSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label="Worktype"
        onChange={(newVal) => {
          onChange(newVal)
          setSelectedValue(newVal)
        }}
        labelKey="description"
        valueKey="workflowTypeId"
        items={options}
        value={selectedValue}
        searchable
        idLabelKey="workflowTypeId"
        showIdInResults={true}
        name="workflowType"
        size={size}
        required={required}
        errors={errors}
        multi={multiple}
        hideMultiCheck
      />
    </div>
  )
}

WorktypeSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.object,
  multiple: PropTypes.bool
}
